import { createMuiTheme } from '@material-ui/core/styles';

export const instajobTheme = createMuiTheme({
    palette: {
        common: {
            black: "#212121",
            white: "#ffffff"
        },
        type: "light",
        primary: {
            light: "#214E8A",
            main: "#0f233e",
            dark: "#04090F",
            contrastText: "#fff"
        },
        secondary: {
            light: "#FF4D4C",
            main: "#ec2e48",
            dark: "#8F1B2B",
            contrastText: "#fff"
        },
        background: {
            paper: "#ffffff",
            default: "#eaeaea"
        }
    }
});

export const instajobThemeDark = createMuiTheme({
    palette: {
        type: "dark",
        common: {
            black: "#212121",
            white: "#ffffff"
        },
        primary: {
            light: "#FF4D4C",
            main: "#ec2e48",
            dark: "#8F1B2B",
            contrastText: "#fff"
        },
        secondary: {
            light: "#214E8A",
            main: "#0f233e",
            dark: "#04090F",
            contrastText: "#fff"
        },
        background: {
            paper: "#0f233e",
            default: "#214E8A"
        }
    }
});